import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import AccountCard from '../../../../../cards/components/AccountCard';
import NativeActivityIndicator from '../../../../../../components/global/NativeActivityIndicator';
import DesignEditorPreviewPane from '../../../../../../components/global/DesignEditor/components/DesignEditorPreviewPane';

const propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  accountCard: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  onElementConfigurationChange: PropTypes.func.isRequired,
  cardElementLoading: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
};

const AdminPurchasedCustomPrintConfiguratorPreviewPane = ({
  className,
  loading,
  accountCard,
  onElementConfigurationChange,
  cardElementLoading,
}) => {
  const classes = classNames({
    'is-loading': loading,
    [className]: !!className,
  });

  if (loading && !accountCard) {
    return (
      <div className={classes}>
        <NativeActivityIndicator />
      </div>
    );
  }

  return (
    <DesignEditorPreviewPane className={classes}>
      {accountCard && (
        <Fragment>
          <AccountCard
            className="admin-purchased-custom-print-configurator-account-card"
            onElementConfigurationChange={onElementConfigurationChange}
            accountCard={accountCard}
            cardElementLoading={cardElementLoading}
            allowPhotoChange={false}
            disablePhotoWatermarkOverlay
          />
          <p className="text-sm text-italic mt-2 mb-0">
            Press on the photo to adjust crop and placement.
          </p>
        </Fragment>
      )}
    </DesignEditorPreviewPane>
  );
};

AdminPurchasedCustomPrintConfiguratorPreviewPane.propTypes = propTypes;

export default AdminPurchasedCustomPrintConfiguratorPreviewPane;
